import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { STORAGE_KEYS } from '@/shared/lib/constants';
import { env } from '@/shared/lib/env';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/it';
dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale('it');

const stored = localStorage.getItem(STORAGE_KEYS.lang);
const initialLang = stored ?? env.VITE_DEFAULT_LANG;

void i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'it-IT',
    debug: import.meta.env.DEV,
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    backend: {
      // Local fallback bundle; real translations come from BE post-login
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: { useSuspense: false },
  });

export async function changeLanguage(lang: string): Promise<void> {
  localStorage.setItem(STORAGE_KEYS.lang, lang);
  await i18next.changeLanguage(lang);
}

export { i18next };
